const trimEnd = require('lodash.trimend');

function getMinifiedUrl(url) {
    if (typeof url !== 'string') {
        return url;
    }

    return trimEnd(url.replace(/(https?:\/\/)?(www\.)?/i, ''), '/');
}



export {
    getMinifiedUrl
}